import { defineStore } from 'pinia'
import notificationAPI from '@vue3/api/notification-api.js'

const notificationStore = defineStore('notificationStore', {
  state: () => ({
    notificationsList: [],
    currentPage: 0,
    totalRecords: 0,
    pageSize: 20,
    isLoadingNotifications: false,
    unreadCount: 0
  }),
  actions: {
    saveToken ({ data, success, fail }) {
      notificationAPI.saveToken(data).then(
        res => {
          const resBody = res.body
          if (resBody && resBody.success) {
            success && success(resBody)
          } else {
            fail && fail(resBody)
          }
        },
        err => {
          fail && fail(err)
        }
      )
    },
    deleteToken ({ data, success, fail }) {
      notificationAPI.deleteToken(data).then(
        res => {
          const resBody = res.body
          if (resBody && resBody.success) {
            success && success(resBody)
          } else {
            fail && fail(resBody)
          }
        },
        err => {
          fail && fail(err)
        }
      )
    },
    updateTime ({ data, success, fail }) {
      notificationAPI.updateTime(data).then(
        res => {
          const resBody = res.body
          if (resBody && resBody.success) {
            success && success(resBody)
          } else {
            fail && fail(resBody?.errorCode)
          }
        },
        err => {
          fail && fail(err)
        }
      )
    },
    getNotifications ({ query, success, fail, isLoadMore = false }) {
      this.isLoadingNotifications = true
      notificationAPI.getNotifications(query).then(res => {
        const resBody = res.body
        if (resBody?.success && resBody.errorCode === null) {
          if (isLoadMore) {
            this.notificationsList = [...this.notificationsList, ...resBody.content]
          } else {
            this.notificationsList = resBody.content || []
          }

          this.currentPage = resBody.pageMetaData?.pageNumber || 0
          this.totalRecords = resBody.pageMetaData?.totalRecords || 0
          this.unreadCount = resBody.unreadCount || 0
          this.isLoadingNotifications = false

          success && success(resBody)
        } else {
          this.isLoadingNotifications = false
          fail && fail(resBody)
        }
      }).catch(err => {
        this.isLoadingNotifications = false
        fail && fail(err)
      })
    },
    markAsRead ({ data, success, fail }) {
      notificationAPI.markAsRead(data).then(
        res => {
          const resBody = res.body
          if (resBody && resBody.success) {
            this.updateNotificationReadStatus(data.notificationId, true)
            success && success()
          } else {
            fail && fail(resBody)
          }
        },
        err => {
          fail && fail(err)
        }
      )
    },

    resetNotificationData () {
      this.notificationsList = []
      this.currentPage = 0
      this.totalRecords = 0
      this.isLoadingNotifications = false
    },

    updateNotificationReadStatus (id, isRead) {
      const notification = this.notificationsList.find(n => n.id === id)
      if (notification) {
        notification.isRead = isRead
        if (isRead && this.unreadCount > 0) {
          this.unreadCount -= 1
        }
      }
    }
  }
})

export default notificationStore
